
	import { Options, Vue } from "vue-class-component";
	import AvailableTickets from "./AvailableTickets.vue";
  import { mapGetters } from 'vuex';
  import axios from "axios";

	@Options({
		components: {
			AvailableTickets
		},
		created() {
      if (this.$route.query.ticket != undefined) {
        this.$store.commit('Booking/startBooking');  
      }
		},

		data() {
			return {
        searching: false,
        ticket_departure: '',
        ticket_destination: '',
        booking_date: '',
        today_date: '',
        tomorrow_date: '',

        isOpen: false,
        results: [],
        search: '',
        isLoading: false,
        arrowCounter: 0,
        _items:[],
        // perPage:100,
        // pageNumber:1
        isOpenTwo: false,
        resultsTwo: [],
        searchTwo: '',
        isLoadingTwo: false,
        arrowCounterTwo: 0,
        _itemsTwo:[],
			}
		},
    methods: {
      SearchTicket() {
        if (this.ticket_departure == '') {
          alert('Please provide your departure');
          return;
        }

        if (this.ticket_destination == '') {
          alert('Please provide your destination');
          return;
        }

        if (this.booking_date == '') {
          alert('Please provide your booking date');
          return;
        }

        this.searching = true;

        let __tickets_api = 'https://bookinga.herokuapp.com/api/v1/busSchedule';
        let config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("jwt")
          }
        }

        axios.get(`${__tickets_api}`, config)
          .then(response => {
            this.searching = false;
            let searchData ={
              "departure": this.ticket_departure,
              "destination": this.ticket_destination,
              "date": this.booking_date,
              "results": response.data
            }
            this.$store.commit('Search/searchComplete', searchData);
          }).catch((err) => {
            this.searching = false;
            return;
          }) 
      },

      //autocomplete for the source route
      onChange() {
        this.isLoading = true;
        this.isOpenTwo = false;
        this.isOpen = true;
        this.results = this.$store.state.Search.search_promot_data;
        this._items = this.$store.state.Search.search_promot_data;
        this.filterResults();
        this.isLoading = false;
          // Let's warn the parent (whatever using this component) that a //change was madethis.$emit('input', this.search);
          // Is the data given by an outside ajax request? (server-side)
          // if (this.isAsync && this.api != null) {
          //     this.isLoading = true;
          //     this.isOpen = true;
          //     this.api(this.ticket_departure, this.perPage, this.pageNumber).then((d:any) => {
          //         this.results =d.data.map((v:any)=>v.Title);
          //     }).finally(()=>{this.isLoading = false});
          // } else {
          //     // Let's filter our internal array (client-side)this.filterResults();
          //     this.isOpen = true;
          // }
      },
      filterResults() {
          // first uncapitalize all the things
          this.results = this._items.filter((item: any) => {
            return item.toLowerCase().indexOf(this.ticket_departure.toLowerCase()) > -1;
          });
      },
      setResult(result:any) {
          this.ticket_departure = result;
          this.isOpen = false;
        //emit the changes so the parent component will get notifiedthis.$emit('input', this.search);
      },
      onArrowDown(evt:any) {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },
      onEnter() {
        this.ticket_departure = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
        this.$emit('input', this.ticket_departure);
      },
      //this will close the drop-down section when the user click some where// out side of the component
      handleClickOutside(evt:any) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      },

      //autocomplete for the destination route
      onChangeTwo() {
        this.isLoadingTwo = true;
        this.isOpen = false;
        this.isOpenTwo = true;
        this.resultsTwo = this.$store.state.Search.search_promot_data;
        this._itemsTwo = this.$store.state.Search.search_promot_data;
        this.filterResultsTwo();
        this.isLoadingTwo = false;
      },
      filterResultsTwo() {
        this.resultsTwo = this._itemsTwo.filter((item: any) => {
          return item.toLowerCase().indexOf(this.ticket_destination.toLowerCase()) > -1;
        });
      },
      setResultTwo(result:any) {
          this.ticket_destination = result;
          this.isOpenTwo = false;
      },
      onArrowDownTwo(evt:any) {
        if (this.arrowCounterTwo < this.resultsTwo.length) {
          this.arrowCounterTwo = this.arrowCounterTwo + 1;
        }
      },
      onArrowUpTwo() {
        if (this.arrowCounterTwo > 0) {
          this.arrowCounterTwo = this.arrowCounterTwo - 1;
        }
      },
      onEnterTwo() {
        this.ticket_destination = this.resultsTwo[this.arrowCounterTwo];
        this.isOpenTwo = false;
        this.arrowCounterTwo = -1;
        this.$emit('input', this.ticket_destination);
      },
      handleClickOutsideTwo(evt:any) {
        if (!this.$el.contains(evt.target)) {
          this.isOpenTwo = false;
          this.arrowCounterTwo = -1;
        }
      },
      removeAutoCompleteOne() {
        this.isOpen = false;
        this.isOpenTwo = false;
      },
      removeAutoCompleteTwo() {
        this.isOpen = false;
        this.isOpenTwo = false;
      }

    },
		
		computed: {
			...mapGetters({
				allTickets: 'Booking/allTickets'
			}),
		},

		mounted() {
      this.$store.commit('Search/getAllBreakPoints');
			this.$store.dispatch('Booking/getTickets');
      let getDataInterval = setInterval(() => {
        if (this.allTickets.length > 0) {
          if (this.$store.state.Booking.allTickets) {
            this.$store.commit('Search/generateBookingDates', this.allTickets);
            clearInterval(getDataInterval);
          }
        }
      }, 1000)

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();

      this.today_date = mm + '/' + dd + '/' + yyyy;

      let tomorrom = String(today.getDate() + 1).padStart(2, '0');
      var mmtom = String(today.getMonth() + 1).padStart(2, '0');
      var yyyytom = today.getFullYear();

      this.tomorrow_date = mmtom + '/' + tomorrom + '/' + yyyytom;

		}	
	})
export default class Bus extends Vue {}
